import * as R from 'ramda';
var str2Json = R.when(R.is(String), function (str) {
    try {
        return JSON.parse(str);
    }
    catch (e) {
        return str;
    }
});
var json2Str = function (str) { return (!str || typeof str === 'string' ? str : JSON.stringify(str)); };
var StorageBrowser = /** @class */ (function () {
    function StorageBrowser(storage) {
        var _this = this;
        if (storage === void 0) { storage = localStorage; }
        this.storage = storage;
        this.setItem = function (key, value) {
            _this.storage.setItem(key, json2Str(value));
        };
        this.getItem = function (key) { return str2Json(_this.storage.getItem(key)); };
        this.removeItem = function (key) { return _this.storage.removeItem(key); };
        this.clear = function () { return _this.storage.clear(); };
    }
    return StorageBrowser;
}());
export { StorageBrowser };
//# sourceMappingURL=storage-browser.js.map